// extracted by mini-css-extract-plugin
module.exports = {"alert":"billingForPLG3_alert__1URm9","alertMessage":"billingForPLG3_alertMessage__36B69","content":"billingForPLG3_content__3aNr0","button":"billingForPLG3_button__1yJBk"};